import { Select } from "antd"
import React, { useEffect, useState } from "react"
const { Option } = Select;

const all = {
    city: "Вся Россия",
    lat: "61.50332662247493",
    lng: "99.39546946484371",
}

export const Directory = ({ cities, getDistributors }) => {
    

    const [ city, setCity ] = useState([])

    useEffect(()=> {
        let fitered 
        if(cities.length) {
            fitered = cities.filter((elem, idx, arr) => arr.findIndex(item=>(item.city === elem.city)) === idx)
            fitered.unshift(all)
        }
        
        setCity(fitered)
    }, [cities])

    return (
        <div>
            <Select
                showSearch
                style={{ width: "100%", padding: "0 7px" }}
                placeholder="Найти по городу"
                optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
                {city && city.map((item, i)=> 
                    <Option key={i} value={item.city.toLocaleLowerCase()}
                        onClick={()=> 
                            getDistributors(item.city.toLocaleLowerCase(), 
                                { center: [ item.lat, item.lng], zoom: item.city === 'Вся Россия' ? 2 : 10}
                            )}
                    >{item.city}</Option>)}
            </Select>
        </div>
    )
}




// WEBPACK FOOTER //
// ./src/components/pages/projects/distributors/Directory.js